import VBottomSheet from './VBottomSheet';
export { VBottomSheet };
export default VBottomSheet;
//# sourceMappingURL=index.js.map